/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
import { Switch, Redirect, Route } from 'react-router';
// material
import { Division } from '@insticator/insticator-ui'; // iui-material
// pages
import ProductManagerConfig from './productmanagerconfig/productmanagerconfig';
import ProductManagerConfigV2 from './productmanagerconfig/productmanagerconfigv2';
// styles
import injectSheet from 'react-jss';
import styles from './productmanager_styles';


/* ========== ~~~~~~~~~~ PRODUCT MANAGER DIVISION ~~~~~~~~~~ ========== */

export default injectSheet(styles)((props) => {

  return (
    <Division name={`productmanager`} klass={props.classes.productmanager}>
      <Switch>
        {/*Routes to subdivisions*/}
        <Route exact path={'/dashboard/productmanager'} component={ProductManagerConfigV2} />
        <Redirect to='/error/404'/>
      </Switch>
    </Division>
  )
})